import { useState } from 'react';
import { Box } from '@chakra-ui/react';
import CommentText from './CommentText';
import CbReactions from '../../CbReactions/CbReactions';
import { CbAreYouSureModal } from 'ui/components/CbAreYouSureModal';
import { useRelativeTime } from 'hooks';
import style from './CommentItem.module.css';
import CommentHeader from './CommentHeader';
import classnames from 'classnames';
import { Comment } from 'types/Comment';
interface CommentsProps {
  comment: Comment;
  maxDisplayLength?: number;
  isTopComment?: boolean;
  deleteComment: (commentId: number) => void;
}
const CommentItem = ({
  comment,
  deleteComment,
  maxDisplayLength = 200,
  isTopComment = false
}: CommentsProps) => {
  const {
    body
  } = comment;
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const {
    id,
    user,
    reactions,
    createdAt
  } = comment;
  const onClose = () => setIsOpen(false);
  const itemAge = useRelativeTime(createdAt);
  return <Box className={classnames(style.commentContainer, {
    [style.topCommentContainer]: isTopComment
  })} key={id} data-sentry-element="Box" data-sentry-component="CommentItem" data-sentry-source-file="CommentItem.tsx">
      <CommentHeader user={user} itemAge={itemAge} isTopComment={isTopComment} openDeleteModal={setIsOpen} data-sentry-element="CommentHeader" data-sentry-source-file="CommentItem.tsx" />
      <CommentText body={body} maxDisplayLength={maxDisplayLength} data-sentry-element="CommentText" data-sentry-source-file="CommentItem.tsx" />
      <CbReactions itemId={id} itemType="Comment" showHelperText={false} itemReactions={reactions} data-sentry-element="CbReactions" data-sentry-source-file="CommentItem.tsx" />
      <CbAreYouSureModal confirmButtonVariant="danger" isOpen={isOpen} onClose={onClose} headerText="Are you sure you want to delete this comment?" confirmText="Delete" denyText="Cancel" onConfirm={() => {
      deleteComment(id);
      onClose();
    }} data-sentry-element="CbAreYouSureModal" data-sentry-source-file="CommentItem.tsx" />
    </Box>;
};
export default CommentItem;